<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template(v-if="settings.withTime && settings.showTime && parametersFrom === 'homework'")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
						| {{ settings.showTime }}
						| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_mode')}}:
								| {{ $i18n.tc('trainer.trainer_gameFormSettingValue_' + settings.mode, 0) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') }}:
								| {{ settings.numOfUnknowns }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
								| {{ settings.numOfExamples }}
						br
						template(v-if='settings.exampleComplication')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_examplesComplication') }}:
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
								br
						span(v-if='!settings.withTime')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
								| {{ settings.tableSize }} x {{ settings.tableSize }}
								br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
